






import { Vue, Component } from 'vue-property-decorator'
import { UserModule } from './store/modules/user'

@Component
export default class App extends Vue {
}
